import React from 'react';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // E

import hljs from 'highlight.js';
import 'highlight.js/styles/monokai-sublime.css';

hljs.configure({
  // optionally configure hljs
  languages: ['javascript', 'ruby', 'python', 'c', 'php', 'html', 'css'],
});

const modules = {
  history: {
    // Enable with custom configurations
    delay: 2500,
    userOnly: true,
  },
  syntax: {
    highlight: (text) => hljs.highlightAuto(text).value,
  },
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],
    ['link', 'image', 'video'],

    [{ header: 1 }, { header: 2 }, { header: [1, 2, 3, 4, 5, 6, false] }, { size: ['small', false, 'large', 'huge'] }], // custom button values

    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '+1' }, { indent: '-1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],

    ['clean'], // remove formatting button
  ],
};

const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'link',
  'image',
  'video',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
  'code-block',
  'color',
  'background',
  'align',
  'script',
  'direction',
];

class Quill extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ReactQuill
        style={{ margin: '1em 0.9em 0em 0.9em' }}
        margin="normal"
        theme="snow"
        value={this.props.text}
        modules={modules}
        formats={formats}
        onChange={this.props.onChange}
        placeholder="Enter text here..."
      />
    );
  }
}

export default Quill;
